module.exports = __webpack_public_path__ + "img/task_missions_block.2bd5095b.svg";